(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const BATCH = 14;

    function initLoadMore(sectionId) {
      const grid = document.getElementById('recs-grid-' + sectionId);
      const wrapper = document.getElementById('load-more-wrapper-' + sectionId);
      if (!grid || !wrapper) return;

      const btn = wrapper.querySelector('.recommendations-load-more__btn');
      const hiddenItems = Array.from(grid.querySelectorAll('.recs-hidden'));

      if (hiddenItems.length === 0) {
        wrapper.style.display = 'none';
        return;
      }

      // Show the Load More button since there are hidden items
      wrapper.style.display = 'flex';

      let shown = 0;

      btn.addEventListener('click', function () {
        const nextBatch = hiddenItems.slice(shown, shown + BATCH);
        nextBatch.forEach(function (item) {
          item.classList.remove('recs-hidden');
          item.classList.add('recs-visible');
        });
        shown += BATCH;

        if (shown >= hiddenItems.length) {
          wrapper.style.display = 'none';
        }
      });
    }

    // Wait for product-recommendations custom element to finish loading
    function waitForRecs(sectionId, attempts) {
      attempts = attempts || 0;
      if (attempts > 20) return;

      const grid = document.getElementById('recs-grid-' + sectionId);
      if (grid && grid.querySelector('.resource-list__item')) {
        initLoadMore(sectionId);
      } else {
        setTimeout(function () {
          waitForRecs(sectionId, attempts + 1);
        }, 300);
      }
    }

    document.querySelectorAll('[data-testid="product-recommendations-section"]').forEach(function (el) {
      const sectionId = el.dataset.sectionId;
      waitForRecs(sectionId);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
